"use client";

import { c as _c } from "react/compiler-runtime";
import { Modal } from "@opensea/ui-kit";
import { useSnapshot } from "valtio";
import { FlowActions, FlowState } from "../../stores/flowStore";
import { EnforceCreatorFeesFlow } from "./EnforceCreatorFeesFlow/EnforceCreatorFeesFlow";
import { SetRoyaltyInfoFlow } from "./SetRoyaltyInfoFlow/SetRoyaltyInfoFlow";
import { UnenforceCreatorFeesFlow } from "./UnenforceCreatorFeesFlow/UnenforceCreatorFeesFlow";
export const ModalFlows = () => {
  const $ = _c(9);
  const {
    flow
  } = useSnapshot(FlowState);
  let t0;
  if ($[0] !== flow) {
    t0 = () => {
      switch (flow?.type) {
        case "enforce-creator-fees":
          {
            return <EnforceCreatorFeesFlow {...flow} />;
          }
        case "unenforce-creator-fees":
          {
            return <UnenforceCreatorFeesFlow {...flow} />;
          }
        case "set-royalty-info":
          {
            return <SetRoyaltyInfoFlow {...flow} />;
          }
        default:
          {
            return null;
          }
      }
    };
    $[0] = flow;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const renderContent = t0;
  const t1 = flow;
  let t2;
  if ($[2] !== t1) {
    t2 = isModalFlow(t1);
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const isModalFlowActive = t2;
  let t3;
  if ($[4] !== renderContent) {
    t3 = renderContent();
    $[4] = renderContent;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== isModalFlowActive || $[7] !== t3) {
    t4 = <Modal content={t3} onOpenChange={_temp} open={isModalFlowActive} size="sm" />;
    $[6] = isModalFlowActive;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
const MODAL_FLOWS = new Set(["enforce-creator-fees", "unenforce-creator-fees", "set-royalty-info"]);
function isModalFlow(flow) {
  return !!flow && MODAL_FLOWS.has(flow.type);
}
function _temp(open) {
  if (!open) {
    FlowActions.endFlow();
  }
}